export enum PasswordRecoverStatus {
  EmailInput = 1,
  SendingLink,
  LinkSent
}

export enum PasswordResetStatus {
  PasswordInput = 1,
  Resetting,
  Success,
  Failed
}

export interface PasswordState {
  recoverStatus: PasswordRecoverStatus;
  recoverEmail: string;

  reset: {
    status: PasswordResetStatus;
  };
}

export const initialState: PasswordState = {
  recoverStatus: PasswordRecoverStatus.EmailInput,
  recoverEmail: null,
  reset: {
    status: PasswordResetStatus.PasswordInput
  }
};
